import { Link } from "@shopify/hydrogen";

const AvaNavItems = (props) => {
  const { collections, active, id, closeNav } = props;
  return (
    <>
      {collections && (
        <div
          className={`top-[90px] fixed left-0 right-0 w-[100%] pt-10 z-[60] p-8 bg-[#FFFFFFF2] bg-opacity-95 gap-[4%] text-black transition-opacity duration-300 flex justify-center ${
            active === id ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
        >
          {collections.map((collectionItem, index) => {
            return (
              <div
                onClick={() => {
                  closeNav(null);
                }}
                key={index}
                className="flex flex-col justify-start items-start p-1 gap-2"
              >
                <Link
                  to={" " + collectionItem.handle}
                  className="flex justify-start items-start uppercase font-gotham-bold"
                >
                  {collectionItem.label}
                </Link>
                {collectionItem.sub_collections.map((subCollectionItem, i) => {
                  return (
                    subCollectionItem.label.length > 0 && (
                      <div key={i}>
                        <Link to={" " + subCollectionItem.handle} key={i}>
                          <div className="w-full">
                            <p className="font-gotham-light text-[13px] text hover:underline uppercase">
                              {subCollectionItem.title}
                            </p>
                            <p className="font-gotham-light text-[13px] hover:underline">
                              {subCollectionItem.sub_title}
                            </p>
                          </div>
                          <div>
                            <p className="font-gotham-bold text-[13px]  hover:underline w-full">
                              {subCollectionItem.view_title}
                            </p>
                          </div>
                        </Link>
                      </div>
                    )
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
export default AvaNavItems;
